import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "13px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          cursor: "pointer",
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const AddLeadStatus = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editData = {},
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (editData?.id) {
      formik.setFieldValue("status_code", editData?.status_code);
      formik.setFieldValue("status_name", editData?.status_name);
      formik.setFieldValue("category", editData?.category);
      formik.setFieldValue("recyclable", editData?.recyclable);
      formik.setFieldValue("recycle_days", editData?.recycle_days);
      formik.setFieldValue("requires_follow_up", editData?.requires_follow_up);
      formik.setFieldValue("description", editData?.description);
    }
  }, [editData]);

  const category = [
    {
      key: "Open",
      value: "Open",
    },
    {
      key: "Closed",
      value: "Closed",
    },
    {
      key: "Working",
      value: "Working",
    },
    {
      key: "Hot",
      value: "Hot",
    },
    {
      key: "Won",
      value: "Won",
    },
    {
      key: "Lost",
      value: "Lost",
    },
  ];

  const typeArray = [
    {
      key: "Yes",
      value: "yes",
    },
    {
      key: "No",
      value: "no",
    },
  ];

  const categoryList = category?.map((each) => ({
    value: each.value,
    label: each.key,
  }));
  const typeOptions = typeArray?.map((each) => ({
    value: each.value,
    label: each.key,
  }));

  const validationSchema = yup.object({
    status_code: yup

      .string("This Field is Required")
      .min(2, "Must be at least 2 characters")
      .max(5, "Must be at most 5 characters")
      .required("This Field is Required"),

    status_name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    category: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    recyclable: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    recycle_days: yup
      .number("This Field is Required")
      .required("This Field is Required"),
    requires_follow_up: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    description: yup
      .string("This Field is Required")
      .required("This Field is Required"),
  });

  const formik = useFormik({
    initialValues: {
      status_code: "",
      status_name: "",
      category: "",
      recyclable: "",
      recycle_days: "",
      requires_follow_up: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let data = {
        status_code: values.status_code,
        status_name: values.status_name,
        category: values.category,
        recyclable: values.recyclable,
        recycle_days: values.recycle_days,
        requires_follow_up: values.requires_follow_up,
        description: values.description,
      };

      // console.log("Form data", values);
      // console.log("Extra meta" , extra_meta);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: editData?.id
            ? `status-config/update-status/${editData?.id}`
            : `status-config/add-status`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{editData?.id ? "Edit Lead Status" : "Add Lead Status"}</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Status Code */}
                  <FeildWraper>
                    <FormLabel required>Status Code</FormLabel>
                    <input
                      type="text"
                      name="status_code"
                      value={formik.values.status_code}
                      onChange={formik.handleChange}
                      placeholder="Status Code"
                    />
                    {formik.touched.status_code &&
                      formik.errors.status_code && (
                        <FeildError>{formik.errors.status_code}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Status Name */}

                  <FeildWraper>
                    <FormLabel required>Status Name</FormLabel>
                    <input
                      type="text"
                      name="status_name"
                      value={formik.values.status_name}
                      onChange={formik.handleChange}
                      placeholder="Status Name"
                    />
                    {formik.touched.status_name &&
                      formik.errors.status_name && (
                        <FeildError>{formik.errors.status_name}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Category */}
                  <FeildWraper>
                    <FormLabel required>Category</FormLabel>
                    <CustomSelect
                      name="category"
                      options={categoryList}
                      formik={formik}
                      placeholder="Select category..."
                    />
                    {formik.touched.category && formik.errors.category && (
                      <FeildError>{formik.errors.category}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Recyclable  */}
                  <FeildWraper>
                    <FormLabel required>Recyclable</FormLabel>
                    <CustomSelect
                      name="recyclable"
                      options={typeOptions}
                      formik={formik}
                      placeholder="Recyclable"
                    />
                    {formik.touched.recyclable && formik.errors.recyclable && (
                      <FeildError>{formik.errors.recyclable}</FeildError>
                    )}
                  </FeildWraper>

                  {/* Recycle Days */}
                  <FeildWraper>
                    <FormLabel required>Recycle Days</FormLabel>
                    <input
                      type="number"
                      name="recycle_days"
                      min="0"
                      value={formik.values.recycle_days}
                      onChange={formik.handleChange}
                      placeholder="Recycle Days"
                    />
                    {formik.touched.recycle_days &&
                      formik.errors.recycle_days && (
                        <FeildError>{formik.errors.recycle_days}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Require Follow Up */}

                  <FeildWraper>
                    <FormLabel required>Require Follow Up</FormLabel>
                    <CustomSelect
                      name="requires_follow_up"
                      options={typeOptions}
                      formik={formik}
                      placeholder="Require Follow Up"
                    />
                    {formik.touched.requires_follow_up &&
                      formik.errors.requires_follow_up && (
                        <FeildError>
                          {formik.errors.requires_follow_up}
                        </FeildError>
                      )}
                  </FeildWraper>

                  {/* description */}
                  <FeildWraper width="100%">
                    <FormLabel required>Description</FormLabel>

                    <textarea
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      rows={6}
                      placeholder="Write description here..."
                    />
                    {formik.touched.description &&
                      formik.errors.description && (
                        <FeildError>{formik.errors.description}</FeildError>
                      )}
                  </FeildWraper>
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {editData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddLeadStatus;
